var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFolder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_403_3005)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19 3.00024H12.472C12.3173 3.00127 12.1645 2.96707 12.025 2.90024L8.869 1.31624C8.45239 1.10879 7.9934 1.00063 7.528 1.00024H5C3.67441 1.00183 2.40356 1.52913 1.46622 2.46646C0.528882 3.4038 0.00158786 4.67465 0 6.00024L0 18.0002C0.00158786 19.3258 0.528882 20.5967 1.46622 21.534C2.40356 22.4714 3.67441 22.9987 5 23.0002H19C20.3256 22.9987 21.5964 22.4714 22.5338 21.534C23.4711 20.5967 23.9984 19.3258 24 18.0002V8.00024C23.9984 6.67465 23.4711 5.4038 22.5338 4.46646C21.5964 3.52913 20.3256 3.00183 19 3.00024ZM5 3.00024H7.528C7.68266 2.99922 7.83552 3.03342 7.975 3.10024L11.131 4.67924C11.5472 4.88843 12.0062 4.99831 12.472 5.00024H19C19.598 5.00122 20.1821 5.18091 20.6773 5.51626C21.1725 5.8516 21.5561 6.32728 21.779 6.88224L2 6.99424V6.00024C2 5.20459 2.31607 4.44153 2.87868 3.87892C3.44129 3.31631 4.20435 3.00024 5 3.00024ZM19 21.0002H5C4.20435 21.0002 3.44129 20.6842 2.87868 20.1216C2.31607 19.559 2 18.7959 2 18.0002V8.99424L22 8.88124V18.0002C22 18.7959 21.6839 19.559 21.1213 20.1216C20.5587 20.6842 19.7956 21.0002 19 21.0002Z",
    fill: "#374957"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_403_3005"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolder);
export default __webpack_public_path__ + "static/media/folder.e4ea8eb0f968c3c7c3a82b7ec194bfc9.svg";
export { ForwardRef as ReactComponent };